import { CITY_SLUG } from 'dpl/constants/query_params';

export function puppiesResourceDefinition(
  breedId,
  itemsPerPage,
  currentPage,
  filters
) {
  return {
    url: `/api/breeds/${breedId}/puppies.json`,
    params: {
      per_page: itemsPerPage,
      page: currentPage,
      ...filters
    },
    defaultValue: {
      meta: {
        available_delivery_methods: []
      },
      data: []
    }
  };
}

export function puppyAndBreederCountsResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/puppy_and_breeder_counts.json`,
    params: {
      ...filters
    }
  };
}

export function nearbyBreederProfilesResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/nearby_breeder_profiles.json`,
    params: filters
  };
}

export function nearbyOwnerStoriesResourceDefinition(breedId, citySlug) {
  return {
    url: `/api/breeds/${breedId}/nearby_owner_stories.json`,
    params: { [CITY_SLUG]: citySlug },
    defaultValue: { data: [] }
  };
}

export function newsletterSignupMutationDefinition() {
  return {
    url: '/api/email_list_registrations.json',
    method: 'POST'
  };
}
